import * as jsrsasign from "jsrsasign";
import { toast } from "react-toastify";

export const decodeJwtWithJsrs = (token: any) => {
  if (token) {
    try {
      const decodedToken: any = jsrsasign.KJUR.jws.JWS.parse(token);
      return decodedToken?.payloadObj;
    } catch (error) {
      toast.error("Error in parsing the token");
    }
  }
};

const rolesToUrlMapping: any = {
  "User:View": "user-management",
  "User:Create": "user-management",
  "User:Update": "user-management",
  "User:Delete": "user-management",
};

export const modGetAllowedUrls = (roles: any) => {
  const allowedUrls = new Set();
  roles?.forEach((role: any, index: number) => {
    const urls = rolesToUrlMapping?.[role];
    if (urls !== undefined) {
      if (Array.isArray(urls)) {
        urls.forEach((url) => allowedUrls?.add(url));
      } else {
        allowedUrls?.add(urls);
      }
    }
  });
  return allowedUrls;
};

export const formatDateTime = (dateString: string): string => {
  // Parse the date string
  const date = new Date(dateString);

  // Format the date to mm/dd/yyyy
  const formattedDate = `${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}/${String(date.getDate()).padStart(2, "0")}/${date.getFullYear()}`;

  // Format the time to HH:MM:SS
  const formattedTime = `${String(date.getHours()).padStart(2, "0")}:${String(
    date.getMinutes()
  ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;

  // Combine formatted date and time
  return `${formattedDate} ${formattedTime}`;
};

//filtering the permissions based on the page
export const getPermissions = (url: string) => {
  const permissions = JSON.parse(
    localStorage.getItem("dm_userscope") as string
  );
  let pageWisePermissions = [];
  if (url) {
    switch (true) {
      case url.includes("/user-management"):
        pageWisePermissions = Array.isArray(permissions)
          ? permissions.filter((perm: any) => {
            return perm?.split(":")[0] === "User";
          })
          : [];
        break;

      default:
    }
  }
  return pageWisePermissions;
};

export const getPermissionAccess = (operationsArray: any) => {
  if (operationsArray.length > 0) {
    const dynamicPrefix =
      operationsArray.length > 0 ? operationsArray[0].split(":")[0] : "";
    const allOperations = ["Create", "View", "Update", "Delete"];
    const operationsObject = allOperations.reduce((obj: any, operation) => {
      obj[operation] = operationsArray?.includes(
        `${dynamicPrefix}:${operation}`
      );
      return obj;
    }, {});
    return operationsObject;
  } else {
    const sample = { Create: true, View: true, Update: true, Delete: true };
    return sample;
  }
};

// XSM-1536 - SSO Login flow
// Author: Abhishek Bharti
/**
 * Concatenates two text parameters with colon separator and returns the base64 encoded string
 * @param text1 First text parameter
 * @param text2 Second text parameter
 * @returns Base64 encoded string
 */
export const concatAndEncodeBase64 = (text1: string, text2: string): string => {
  const concatenatedString = `${text1}:${text2}`;
  return window.btoa(concatenatedString);
};

const isNotEmptyCheck = (data: any) => {
  return (
    data !== undefined &&
    data !== "undefined" &&
    data !== "" &&
    data !== "null" &&
    data !== null
  );
};

export const getCookie = (cname: string) => {
  let ca, decodedCookie;
  const name = cname + "=";
  if (typeof document !== "undefined") {
    decodedCookie = decodeURIComponent(document.cookie);
    ca = decodedCookie.split(";");
    if (isNotEmptyCheck(ca) && ca.length) {
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          let reqCookieItem = c.substring(name.length, c.length);
          if (cname === "_t_") {
            reqCookieItem = reqCookieItem.substr(19, reqCookieItem.length);
          }
          return reqCookieItem;
        }
      }
    } else return "";
  }
};
